import React from 'react';
import { Users, GraduationCap, UserCheck } from 'lucide-react';

const WhoCanJoinSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-12">
          <div className="relative order-2 lg:order-1">
            <img 
              src="https://images.unsplash.com/photo-1758270704534-fd9715bffc0e?w=800&q=85" 
              alt="Diverse students in modern learning environment"
              className="rounded-2xl shadow-2xl hover-lift"
            />
          </div>
          <div className="order-1 lg:order-2">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Who Can Join CareerLift?
            </h2>
            <p className="text-xl text-gray-600 font-light leading-relaxed">
              Whether you're a student, graduate, or career changer—we're here to help you 
              transform your career and achieve your IT dreams.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="inline-flex p-3 bg-blue-50 rounded-lg mb-4">
              <GraduationCap className="h-6 w-6 text-blue-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">IT Students</h3>
            <p className="text-gray-600 leading-relaxed text-sm">
              Gain real-world experience alongside your studies
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="inline-flex p-3 bg-blue-50 rounded-lg mb-4">
              <Users className="h-6 w-6 text-blue-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">IT Graduates</h3>
            <p className="text-gray-600 leading-relaxed text-sm">
              Launch your career with practical skills
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="inline-flex p-3 bg-blue-50 rounded-lg mb-4">
              <UserCheck className="h-6 w-6 text-blue-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Career Changers</h3>
            <p className="text-gray-600 leading-relaxed text-sm">
              Transition into a successful tech career
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoCanJoinSection;